import React from 'react'
import LabeledValue from '../../../../components/common/LabeledValue'
import Loader from '../../../../components/common/Loader'
import { TimeOffRequestDetails, isVacationBid } from '../../../../store/slices/Requestor/timeOffDetailsSlice'
import { useRetractInlineFlow } from '../../../../hooks/useRetractInlineFlow'
import { getVacationBidAwareTableProps } from './vacationBidOverlapDisplay'
import RetractForm from './RetractForm'
import RightPanel from './RightPanel'
import CurrentRequestSection from './CurrentRequestSection'
import HistorySection from './HistorySection'

interface PartiallyApprovedTimeOffViewProps {
  data: TimeOffRequestDetails
  tableRows: any[]
  highlightedDates: string[]
  handlePrint?: () => void
}

/**
 * Renders the partially approved detail view with the inline retract flow.
 */
const PartiallyApprovedTimeOffView: React.FC<PartiallyApprovedTimeOffViewProps> = ({
  data,
  tableRows,
  highlightedDates,
  handlePrint,
}) => {
  const {
    heading,
    isRetractOpen,
    isSubmittingRetract,
    retractSubmitted,
    partialRetract,
    setPartialRetract,
    comments,
    setComments,
    retractError,
    submitRetractRequest,
    openRetract,
    handleCancel,
  } = useRetractInlineFlow({
    defaultHeading: 'Partially Approved Time Off Request',
    requestId: data.requestId,
    fallbackNuid: data.nuid,
  })

  return (
    <div>
      {isSubmittingRetract && <Loader />}
      <h1 className="h1">{heading}</h1>
      <div className="flex flex-col mobile:gap-4 tablet:gap-6 desktop:gap-8 desktop:flex-row">
        <div className="flex-1">
          {data.papprovedOn && (
            <div className="mb-4">
              <LabeledValue label="Partially Approved On" value={data.papprovedOn} />
            </div>
          )}
          {data.papprovedBy && (
            <div className="mb-4">
              <LabeledValue label="Approved By" value={data.papprovedBy} />
            </div>
          )}
          {(data.requestRank != null || isVacationBid(data)) && (
            <div className="mb-4">
              <LabeledValue label="Request Rank" value={data.requestRank == null ? 'NA' : String(data.requestRank)} />
            </div>
          )}
          {data.partialRefId && (
            <div className="mb-4">
              <LabeledValue label="Denied Time Off Request ID" value={data.partialRefId} />
            </div>
          )}
          <div className="mb-4">
            <LabeledValue label="Approver Comments" value={data.approverComments || '-'} />
          </div>
          {isRetractOpen && !retractSubmitted && (
            <RetractForm
              partialRetract={partialRetract}
              onPartialRetractChange={setPartialRetract}
              comments={comments}
              onCommentsChange={setComments}
              retractError={retractError}
              isSubmitting={isSubmittingRetract}
              onSubmit={submitRetractRequest}
              onCancel={handleCancel}
            />
          )}
          {!isRetractOpen && !retractSubmitted && (
            <button
              type="button"
              className="button -primary -inverted mt-8!"
              onClick={openRetract}
            >
              Retract Request
            </button>
          )}
        </div>
        <RightPanel data={data} variant="full" handlePrint={handlePrint} />
      </div>
      <div className="mt-6!"><hr className="-variation-1" /></div>
      {data.history && data.history.length > 0 && <HistorySection history={data.history} />}
        <CurrentRequestSection {...getVacationBidAwareTableProps(tableRows, isVacationBid(data))} highlightedDates={highlightedDates} />
    </div>
  )
}

export default PartiallyApprovedTimeOffView
